/* eslint-disable no-console */
/* eslint-disable no-restricted-syntax */
import _ from 'lodash';
import { SLTXFormatRootFile } from '../../fileFormats/sltx/sltx';
import { EvaluatedProperties } from '../data/evaluatedProperties';
import { RulesEvaluation } from './rulesEvaluation';
import { TreeOptionSelections } from '../data/optionsSelection';
import { ModelRuleData, ModelRuleDescriptionData } from './modelRuleData';

export class RulesEvaluationProperties {

  public static evaluateRule(
    // The rule to evaluate
    propertiesRule : ModelRuleData,
    // The current selection state
    configSelectionState : TreeOptionSelections,
    // The details about the model
    sltxFile : SLTXFormatRootFile,
    // Model Properties
    properties : EvaluatedProperties,
  ) : EvaluatedProperties {

    console.log('Evaluating Properties Rule: ', propertiesRule.name);

    if (propertiesRule === undefined || propertiesRule.ruleDataProperties === undefined) {
      return properties;
    }

    const { conditions } = propertiesRule.ruleDataProperties;

    // If there are no conditions, return the original properties
    if (conditions.length === 0) {
      console.warn("There are no conditions in the rule, so it won't adjust any properties");
      return properties;
    }

    // Check if the conditions defined are fulfilled
    const allConditionsFulfilled = RulesEvaluation.checkIfConditionsAreFulfilled(
      conditions,
      configSelectionState,
      sltxFile,
    );

    console.log('All conditions fulfilled:', allConditionsFulfilled);

    if (allConditionsFulfilled === false) {
      // If the conditions are not fulfilled, return the original groups
      return properties;
    }

    // If the conditions are fulfilled, then we need to adjust the properties
    const adjustedProperties = this.adjustProperties(
      propertiesRule.ruleDataProperties.descriptions,
      properties,
    );

    console.log('adjustedProperties', adjustedProperties);
    return adjustedProperties;
  }

  private static adjustProperties(
    descriptions : ModelRuleDescriptionData[],
    properties : EvaluatedProperties,
  ) : EvaluatedProperties {

    // We need to go through the descriptions defined in the rule,
    // and adjust the properties
    const adjustedProperties = _.cloneDeep(properties);

    for (const description of descriptions) {

      // Find the property in the properties with the matching ID
      const property = adjustedProperties.find(
        (prop) => prop.propertyID === description.propertyID,
      );

      if (property === undefined) {
        // eslint-disable-next-line no-continue
        continue;
      }

      // Adjusting property value from property.value to description.value
      console.log(`Adjusting property value from ${property.value} to ${description.value}`);
      property.value = description.value || '';
      property.valueFromRules = true;
    }

    return adjustedProperties;
  }

}
